// ReactJs
import React from 'react'
import { useNavigate } from 'react-router'
// Node modules
import styled from 'styled-components'
// Styles
import theme from '@shared/utils/theme'
import Icon from '@shared/components/Icon'

const WelcomePageLinkContainer = styled.div`
  display:flex;
  justify-content: flex-start;
  align-items: center;
  height: 35px;
  background-color: ${ theme.palette.light_grey };
  margin-bottom: 4px;
  cursor: pointer;
  .label {
    margin-left: 20px;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0.266667px;
    text-decoration: underline;
  }

  .path {
    text-align: right;
    flex-grow: 1;
  }

  .open-btn {
    cursor: pointer;
    margin-top: 3px;
    fill: ${ theme.palette.black };
  }
`

export default function WelcomePageLink({ label, path }) {
  const navigate = useNavigate()

  const open = () => {
      navigate(`${ path }`)
  }

  return (
    <WelcomePageLinkContainer onClick={ open }>
      <div className="label">{ label }</div>
      <div className="path">
        <Icon className="open-btn" name="chevron_right" />
      </div>
    </WelcomePageLinkContainer>
  )
}
